import React from 'react';
import { ButtonActionDrop } from '../../../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import dayjs from 'dayjs';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import './BordCard.scss';

interface Bord {
  name: string;
  sum_task?: number;
  date?: string;
  color?: string | null;
  id?: number | string;
  start_time?: string; // для задач
  end_time?: string; // для задач
  created_at?: string;
  count_deals?: number | string;
}

interface BordCardProps {
  name: string;
  count_deals?: number;
  date?: string;
  color?: string | null;
  id: number | string | undefined;
  created_at?: string;
  end_time?: string;
  fetchGetBord: () => void;
  setIsModal: (value: boolean) => void;
  setCurrentBord: (bord: Bord) => void;
  currentBord: Bord | null;
  setIsEdit: (value: boolean) => void;
  crm?: boolean;
  ticket?: boolean
  task?: boolean
}

const BordCard = ({
  name,
  count_deals,
  date,
  color = null,
  id,
  created_at,
  end_time,
  fetchGetBord,
  setIsModal,
  setCurrentBord,
  currentBord,
  setIsEdit,
  crm = false,
  ticket = false,
  task = false
}: BordCardProps) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  // Удаление воронки
  const deleteBord = async () => {
    let url = ` https://portals.ecomru.ru/api/crm/funnels/${id}`;
    if (ticket) {
      url = ` https://portals.ecomru.ru/api/ticket/funnel/${id}?page=1&limit=10000`
    }
    if (task) {
      url = ` https://portals.ecomru.ru/api/v3/tasks/board/delete_task_board`;
    }

    const body = JSON.stringify({ task_board_id: id });

    try {
      const res = await fetch(url, { method: 'DELETE', headers, body });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }

      const json = await res.json();
      fetchGetBord();
    } catch (err) {
      console.error(err);
    }
  };

  const btns = [
    {
      btn: 'Редактировать',
      func: () => {
        setCurrentBord({ name, count_deals, date, id, created_at, start_time: created_at, end_time, color });
        setIsEdit(true);
        setIsModal(true);
      },
    },
    {
      btn: 'Удалить',
      func: deleteBord,
    },
  ];

  const isActive = currentBord?.id === id;

  return (<div
    className={`bord-card ${isActive ? 'bord-card_active' : ''}`}
    style={{ background: color || '' }}
    onClick={() => {
      setCurrentBord({ name, count_deals, date, id, created_at, color });
    }}
  >
    <div className="bord-card__header">
      <h4 className="bord-card__title">{name ? name : 'Нет названия'}</h4>
      <ButtonActionDrop id={1} btns={btns} size="s" />
    </div>
    <div className="bord-card__info">
      {(created_at || end_time) ? (
        <div className="bord-card__date-box">
          <div className="bord-card__date">
            {created_at ? dayjs(created_at).format('DD-MM-YY') : ''}{end_time ? (created_at ? ' - ' : '') + dayjs(end_time).format('DD-MM-YY') : ''}
          </div>
        </div>
      ) : null}
      <div className="bord-card__sum-task">
        {count_deals || 0} {crm ? 'сделок' : (task ? 'задач' : 'ticket')}
      </div>
    </div>
  </div>
  );
};

export { BordCard };